<app-card-section>
    <div class="mb-4 flex justify-between gap-4">
        <div class="flex items-center gap-4">
            <h3 class="text-gray-900 pb-0 text-sm font-semibold md:text-lg">
                Traveler {{ traveler().position }}
                <span class="text-sm font-normal text-deemphasized">{{
                    traveler().is_minor ? '(minor)' : ''
                }}</span>
            </h3>
            <div class="flex gap-2">
                @for (tripName of traveler().trip_names; track tripName) {
                    <div
                        class="mt-1 w-fit rounded-full border border-lightgrey bg-lightergrey px-3 py-1 text-xs md:text-sm">
                        {{ tripName }}
                    </div>
                }
            </div>
        </div>
    </div>

    <form [formGroup]="travelerForm" class="pt-0">
        @if (!isFormComplete()) {
            <div class="flex flex-wrap items-center gap-6">
                <p class="text-sm font-bold">Is minor (under 18)?</p>
                <div class="flex items-center gap-4">
                    <app-custom-radio
                        class="contents"
                        [formControl]="travelerForm.controls.is_minor"
                        [options]="isMinorOptions">
                    </app-custom-radio>
                </div>
            </div>
        }
        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
                <app-custom-input
                    [editable]="!isFormComplete()"
                    placeholder="Enter first name"
                    type="text"
                    required="true"
                    formControlName="first_name"
                    [control]="travelerForm.controls.first_name"
                    label="First Name">
                </app-custom-input>
            </div>
            <div>
                <app-custom-input
                    [editable]="!isFormComplete()"
                    placeholder="Enter last name"
                    type="text"
                    required="true"
                    formControlName="last_name"
                    [control]="travelerForm.controls.last_name"
                    label="Last Name">
                </app-custom-input>
            </div>
            @if (!isMinorSignal()) {
                <div class="md:col-span-2">
                    <app-custom-input
                        [editable]="!isFormComplete()"
                        placeholder="Enter email address"
                        type="email"
                        required="true"
                        email="true"
                        formControlName="email"
                        [control]="travelerForm.controls.email"
                        label="Email Address">
                    </app-custom-input>
                </div>
            }

            <div class="md:col-span-2 md:flex md:justify-end">
                <app-save-button
                    [showLoader]="isSubmitting()"
                    [success]="isFormComplete()"
                    (onClick)="onSubmitTraveler()"
                    [additionalClasses]="[
                        'px-8',
                        'py-2',
                        'text-sm',
                        'font-medium',
                    ]">
                    {{ buttonText() }}
                </app-save-button>
            </div>
        </div>
        @if (error()) {
            <p class="mt-2 text-sm font-bold text-red">{{ error() }}</p>
        }
    </form>
</app-card-section>
